import { ensureNonNullable } from "@neonaut/lib-js/nonNullable";
export default function add([aX, aY], [bX, bY]) {
    return [
        ensureNonNullable(aX) + ensureNonNullable(bX),
        ensureNonNullable(aY) + ensureNonNullable(bY),
    ];
}
